var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnBblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BNB"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BNB",
    clipPath: "url(#clip-BNB)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    transform: "translate(-219.344 -244.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1046",
    "data-name": "Trazado 1046",
    d: "M219.344,276.469v-3.723c.119-.744.248-1.486.356-2.231a29.963,29.963,0,0,1,52.952-14.694,29.362,29.362,0,0,1,5.952,25.2,28.971,28.971,0,0,1-10.109,16.649,29.321,29.321,0,0,1-16.5,6.782c-.591.053-1.178.157-1.767.237h-1.683c-.231-.048-.461-.11-.695-.142-1.622-.222-3.27-.327-4.865-.674a29.913,29.913,0,0,1-23.281-25.047C219.6,278.039,219.466,277.255,219.344,276.469Zm39.331,2.1-9.371,9.333-9.29-9.3-5.325,5.341L249.4,298.65,264.1,283.986Zm-18.666-7.839,9.374-9.378,9.325,9.319,5.333-5.336L249.32,250.653l-14.706,14.688Zm9.293,9.905,6.044-6.037-5.939-5.848-6.017,5.97ZM235.916,274.7l-5.322-5.323-5.218,5.215,5.322,5.318Zm37.531.01-5.373-5.382-5.249,5.27,5.364,5.364Z",
    fill: "#e2bd00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1047",
    "data-name": "Trazado 1047",
    d: "M370.786,526.317l5.423,5.416-14.694,14.673L346.8,531.69l5.325-5.344,9.29,9.31Z",
    transform: "translate(-112.111 -247.76)",
    fill: "#0a0314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1048",
    "data-name": "Trazado 1048",
    d: "M351.575,314.349l-5.4-5.4,14.706-14.7,14.721,14.7-5.333,5.339-9.325-9.324Z",
    transform: "translate(-111.566 -43.598)",
    fill: "#0a0314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1049",
    "data-name": "Trazado 1049",
    d: "M424.987,456.606l-5.912-5.918,6.018-5.974,5.939,5.851Z",
    transform: "translate(-175.685 -175.962)",
    fill: "#0a0314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1050",
    "data-name": "Trazado 1050",
    d: "M279.989,455.177l-5.217,5.213-5.322-5.321,5.218-5.218Z",
    transform: "translate(-44.073 -180.481)",
    fill: "#0a0314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1051",
    "data-name": "Trazado 1051",
    d: "M591.131,454.829l-5.258,5.255-5.365-5.367,5.249-5.273Z",
    transform: "translate(-317.684 -180.123)",
    fill: "#0a0314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnBblack);
export default __webpack_public_path__ + "static/media/BNBblack.c70cb4d8b003427785cdaa7fb31af1f0.svg";
export { ForwardRef as ReactComponent };